import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingClient"] */ "/app/components/landing-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicNavbar"] */ "/app/components/layout/public-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
